module.exports = __webpack_public_path__ + "img/user.45dccbf8.png";